import { render, staticRenderFns } from "./t-orm-item.vue?vue&type=template&id=343157ab&lang=pug"
import script from "./t-orm-item.vue?vue&type=script&lang=js"
export * from "./t-orm-item.vue?vue&type=script&lang=js"
import style0 from "./t-orm-item.vue?vue&type=style&index=0&id=343157ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports